/**
* 字母 b a c g h k o w q p
* 数字 0 1 2 3 4 5 6 7 8 9
*
* @return Map
*/
function getMapData () {
  var map = new Map([
    ['b', '0'],
    ['a', '1'],
    ['c', '2'],
    ['g', '3'],
    ['h', '4'],
    ['k', '5'],
    ['o', '6'],
    ['w', '7'],
    ['q', '8'],
    ['p', '9']
  ])

  return map
}
/**
* 过滤字符串前的“~”
*/
function filterStr (val) {
  if (val != null && val.indexOf('~') > -1) {
    return val.substring(1, val.length)
  }

  if (val != null && val.indexOf('%') > -1) {
    val = val.replace('%7E', '~').replace('%7e', '~')
    return val.substring(1, val.length)
  }
  return val
}

/**
 * 去除所有数字
 */
function removeNum (val) {
  return val.replace(new RegExp('\\d+', 'gm'), '')
}

/**
 * 数字 0 1 2 3 4 5 6 7 8 9
 * 字母 b a c g h k o w q p
 *
 * @param val
 * @return 数字转字母
 */
function getPhoneStr (val) {
  var returnStr = ''
  if (val != null && val.length > 0) {
    for (var i = 0; i < val.length; i++) {
      returnStr += getLetter(val.charAt(i))
    }
  }
  return returnStr
}

/**
* 通过Map值获取key
*
* @return
*/
function getLetter (val) {
  var str = val
  getMapData().forEach(function (value, key) {
    if (val == value) {
      str = key
    }
  })
  return str
}

/***
 * 换位号码中两组数字：第二位和第六位交换，第三位和第五位交换，位数号按从左往右数
 */
function changeNum (val) {
  if (val != null && val != '') {
    var str = ''
    for (var i = 0; i < val.length; i++) {
      if (i == 1 || i == 2 || i == 4 || i == 5) {
        if (i == 1) { str += val[5] }
        if (i == 2) { str += val[4] }
        if (i == 4) { str += val[2] }
        if (i == 5) { str += val[1] }
      } else {
        str += val[i]
      }
    }
    return str
  }
  return val
}

/**
 * 随机插入3个数字
 */
function insertNum (val) {
  var num = radomNum(3)
  for (var i = 0; i < num.length; i++) {
    var inNum = parseInt(radomNum(1))
    var result = val.substring(0, inNum > val.length ? val.length : inNum) + num.charAt(i) +
      val.substring(inNum > val.length ? val.length : inNum, val.length)
    val = result
  }
  return val
}

/**
 * 随机生成i位数字 i<10
 */
function radomNum (val) {
  if (val == '' || isNaN(val)) {
    return
  }
  var sourceStr = '0,1,2,3,4,5,6,7,8,9'
  const arrStr = sourceStr.split(',')
  var result = ''
  var index = 0
  for (let i = 0; i < val; i++) {
    index = parseInt(Math.random() * arrStr.length)
    result += arrStr[index]
  }
  // for (i = 0; i < val; i++) {
  //   index = parseInt(Math.random() * arrStr.length)
  //   result += arrStr[index]
  // }
  return result
}

/**
 * 字符串前增加“~”
 */
function prefixStr (val) {
  return '~' + val
}

/**
 * 字母转数字 字母 b a c g h k o w q p
 * 数字 0 1 2 3 4 5 6 7 8 9
 *
 * @param val
 * @return
 */
function getPhoneNum (val) {
  if (val == '' || val == null) {
    return
  }
  var resuleStr = ''
  for (var i = 0; i < val.length; i++) {
    resuleStr += getMapData().get(val.charAt(i))
  }
  return resuleStr
}

/**
 * ：加密步骤：
 * 1、换位号码中两组数字：第二位和第六位交换，第三位和第五位交换
 * 2、将全部号码转换为对应的字符
 * 3、任意位置插入三个随机数字
 * 4、在步骤3之后的字符串前加上”~”
 *
 * @return
 */
function encryptPhone (phoneStr) {
  if (phoneStr === '' || phoneStr == null) {
    return
  }
  // 1.换位号码中两组数字：第二位和第六位交换，第三位和第五位交换
  phoneStr = changeNum(phoneStr)
  // 2.将全部号码转换为对应的字符
  phoneStr = getPhoneStr(phoneStr)
  // 3.任意位置插入三个随机数字
  phoneStr = insertNum(phoneStr)
  // 4.在步骤3之后的字符串前加上”~”
  phoneStr = prefixStr(phoneStr)
  return phoneStr
}

export default encryptPhone
